module.exports = __webpack_public_path__ + "static/media/project.868fcf18.svg";